var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMealIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "40.000000pt",
    height: "40.000000pt",
    viewBox: "0 0 40.000000 40.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,40.000000) scale(0.100000,-0.100000)",
    fill: "#f5f5f5",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56 391 c-6 -9 23 -39 31 -33 3 2 8 0 11 -4 4 -4 0 -4 -8 1 -8 5 -5 -3 8 -17 18 -20 20 -27 9 -31 -9 -3 -27 8 -43 25 -16 17 -23 27 -15 23 9 -5 12 -4 7 3 -5 9 -13 9 -26 2 -34 -18 -32 -30 10 -80 30 -35 49 -50 67 -50 13 0 34 -5 46 -12 20 -10 21 -10 8 5 -7 10 -26 17 -40 17 -18 0 -38 12 -62 37 -18 21 -22 28 -8 15 31 -27 41 -28 64 -2 17 19 17 21 0 40 -25 28 -3 25 23 -3 12 -13 22 -35 22 -48 0 -14 7 -34 16 -45 15 -19 16 -19 8 1 -4 11 -9 34 -12 52 -3 23 -18 43 -52 72 -52 44 -56 46 -64 32z m4 -76 c19 -19 32 -35 29 -35 -3 0 -20 16 -39 35 -19 19 -32 35 -29 35 3 0 20 -16 39 -35z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299 366 c-39 -27 -49 -43 -49 -84 0 -20 -26 -52 -106 -133 -96 -97 -104 -110 -94 -129 6 -12 19 -20 28 -18 9 2 59 55 110 118 71 89 99 116 120 118 49 6 98 72 90 124 -5 34 -53 36 -99 4z m88 -3 c8 -20 -34 -101 -56 -107 -9 -2 -27 -7 -41 -10 -16 -5 -55 -45 -110 -116 -89 -113 -107 -130 -117 -104 -3 10 30 51 100 123 93 95 106 113 109 147 2 31 10 43 37 61 40 27 69 29 78 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 330 c10 -11 20 -20 23 -20 3 0 -3 9 -13 20 -10 11 -20 20 -23 20 -3 0 3 -9 13 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319 102 c63 -58 71 -69 59 -80 -13 -10 -26 -1 -82 58 -36 39 -66 67 -66 62 0 -4 28 -39 63 -77 47 -51 68 -67 80 -62 40 15 31 38 -39 103 -38 35 -73 63 -79 63 -5 0 23 -30 64 -67z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMealIcon);
export default __webpack_public_path__ + "static/media/mealIcon.aa4678c6010ead27a88b5c4f5c225a8d.svg";
export { ForwardRef as ReactComponent };